import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Targetaudiencefsk() {
  return (
    <div className="audience_fsk p-100">
      <Container>
        <Row>
          <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="resp_order">
            <div className="aud-fsk-img">
              <StaticImage
                src="../../../images/case-studies/fsk/audience.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={930}
                height={687}
              />
            </div>
          </Col>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="aud-fsk-content">
              <h2>
                Target <span>Audience</span>
              </h2>
              <p>
                "FSK"caters to puzzle game enthusiasts, time management
                aficionados, and those whocrave a captivating role-playing
                experience. It appeals to players seeking aharmonious blend of
                strategy, creativity, and storytelling.
              </p>
            </div>
            <div className="aud_top">
              <StaticImage
                src="../../../images/case-studies/fsk/aud_dollar.webp"
                alt="TekRevol"
                className="aud_dollar"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={219}
                height={221}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Targetaudiencefsk;
